import View from './view.js'
import { useDisabled } from './helpers.js'

export default function Logic(props) {
  let disabled = useDisabled(props)

  return <View {...props} disabled={disabled} />
}
